import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "modal-content closure-modal" };
const _hoisted_2 = { class: "modal-header" };
const _hoisted_3 = { class: "modal-body" };
const _hoisted_4 = { class: "instruction" };
const _hoisted_5 = {
    key: 0,
    class: "form-group"
};
const _hoisted_6 = {
    value: "",
    disabled: ""
};
const _hoisted_7 = ["value"];
const _hoisted_8 = {
    key: 1,
    class: "loading-overlay"
};
const _hoisted_9 = { key: 2 };
const _hoisted_10 = { class: "form-row mt-20" };
const _hoisted_11 = { class: "form-group flex-1" };
const _hoisted_12 = { class: "input-with-suggestion" };
const _hoisted_13 = { class: "form-group flex-1" };
const _hoisted_14 = { class: "input-with-suggestion" };
const _hoisted_15 = { class: "gap-row" };
const _hoisted_16 = { class: "form-group mt-15" };
const _hoisted_17 = {
    key: 0,
    class: "warning-text"
};
const _hoisted_18 = {
    key: 3,
    class: "error-message"
};
const _hoisted_19 = {
    key: 4,
    class: "summary-result mt-20"
};
const _hoisted_20 = { class: "summary-grid" };
const _hoisted_21 = { class: "summary-item" };
const _hoisted_22 = { class: "summary-item" };
const _hoisted_23 = {
    key: 0,
    class: "summary-notes"
};
const _hoisted_24 = { class: "success-note" };
const _hoisted_25 = { class: "modal-footer" };
const _hoisted_26 = ["disabled"];
const _hoisted_27 = {
    key: 0,
    class: "spinner"
};
import { ref, onMounted, computed, watch } from 'vue';
import { apiClient } from '@/service/api';
import { UserGeneralKey, UserRole } from "@/models/user.generalkey";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DailyClosureModal',
    props: {
        visible: { type: Boolean },
        restaurantId: {}
    },
    emits: ["close", "success"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const selectedRestaurantId = ref(props.restaurantId || '');
        const restaurants = ref([]);
        // Theoretical values
        const theoreticalCash = ref(0);
        const theoreticalCard = ref(0);
        const theoreticalTotal = computed(() => theoreticalCash.value + theoreticalCard.value);
        // Actual values
        const actualCash = ref(0);
        const actualCard = ref(0);
        const notes = ref('');
        const isLoading = ref(false);
        const isLoadingTotals = ref(false);
        const error = ref('');
        const closureSummary = ref(null);
        const userRole = localStorage.getItem(UserGeneralKey.USER_ROLE);
        const franchiseId = localStorage.getItem(UserGeneralKey.USER_FRANCHISE_ID);
        const isMultiRestaurant = computed(() => {
            return userRole === UserRole.ADMIN || userRole === UserRole.FRANCHISE;
        });
        const currentActualTotal = computed(() => Number(actualCash.value || 0) + Number(actualCard.value || 0));
        const currentGap = computed(() => currentActualTotal.value - theoreticalTotal.value);
        const formatPrice = (price) => {
            return `${Number(price).toFixed(2)} CHF`;
        };
        const fetchRestaurants = async () => {
            if (!isMultiRestaurant.value)
                return;
            try {
                let url = '';
                if (franchiseId && franchiseId !== 'null' && franchiseId !== 'undefined') {
                    url = `/v1/restaurant/franchise/${franchiseId}`;
                }
                else if (userRole === UserRole.ADMIN) {
                    url = '/v1/restaurant/all?limit=1000';
                }
                else {
                    return;
                }
                const response = await apiClient.get(url);
                if (response.data.code === 200) {
                    const result = response.data.data;
                    if (Array.isArray(result)) {
                        restaurants.value = result;
                    }
                    else if (result && Array.isArray(result.items)) {
                        restaurants.value = result.items;
                    }
                    else if (result && result.data && Array.isArray(result.data)) {
                        restaurants.value = result.data;
                    }
                    if (!selectedRestaurantId.value && restaurants.value.length > 0) {
                        selectedRestaurantId.value = restaurants.value[0].id;
                    }
                }
            }
            catch (err) {
                console.error("Failed to fetch restaurants for closure", err);
            }
        };
        const fetchTheoreticalTotals = async () => {
            if (!selectedRestaurantId.value)
                return;
            isLoadingTotals.value = true;
            try {
                const response = await apiClient.get(`/v1/daily-closure/theoretical-totals/${selectedRestaurantId.value}`);
                if (response.data.code === 200) {
                    theoreticalCash.value = response.data.data.cash || 0;
                    theoreticalCard.value = response.data.data.card || 0;
                    // Pre-fill actual values with theoretical values
                    actualCash.value = theoreticalCash.value;
                    actualCard.value = theoreticalCard.value;
                }
            }
            catch (err) {
                console.error("Failed to fetch theoretical totals", err);
            }
            finally {
                isLoadingTotals.value = false;
            }
        };
        // Initial fetch
        onMounted(async () => {
            if (isMultiRestaurant.value) {
                await fetchRestaurants();
            }
            if (selectedRestaurantId.value) {
                await fetchTheoreticalTotals();
            }
        });
        // Watch for restaurant changes to update totals
        watch(selectedRestaurantId, (newId) => {
            if (newId) {
                fetchTheoreticalTotals();
            }
        });
        const handleClosure = async () => {
            if (!selectedRestaurantId.value) {
                error.value = 'Veuillez sélectionner un restaurant.';
                return;
            }
            isLoading.value = true;
            error.value = '';
            try {
                const response = await apiClient.post('/v1/daily-closure/close', {
                    restaurantId: selectedRestaurantId.value,
                    actualCash: actualCash.value,
                    actualCard: actualCard.value,
                    notes: notes.value
                });
                if (response.data.code === 200) {
                    closureSummary.value = response.data.data;
                    emit('success', response.data.data);
                }
                else {
                    error.value = response.data.message || 'Erreur lors de la clôture.';
                }
            }
            catch (err) {
                error.value = err.response?.data?.message || 'Erreur réseau ou serveur.';
            }
            finally {
                isLoading.value = false;
            }
        };
        return (_ctx, _cache) => {
            return (__props.visible)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "modal-overlay",
                    onClick: _cache[9] || (_cache[9] = _withModifiers(($event) => (_ctx.$emit('close')), ["self"]))
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('pos.dailyClosure') || 'Clôture de journée'), 1),
                            _createElementVNode("button", {
                                class: "close-btn",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                            }, "×")
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('pos.closureInstruction') || 'Veuillez saisir les montants réels comptés dans votre caisse pour aujourd\'hui.'), 1),
                            (isMultiRestaurant.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createElementVNode("label", null, _toDisplayString(_ctx.$t('common.selectRestaurant')), 1),
                                    _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedRestaurantId).value = $event)),
                                        class: "form-control",
                                        onChange: fetchTheoreticalTotals
                                    }, [
                                        _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t('common.chooseRestaurant')), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(restaurants.value, (rest) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: rest.id,
                                                value: rest.id
                                            }, _toDisplayString(rest.name), 9, _hoisted_7));
                                        }), 128))
                                    ], 544), [
                                        [_vModelSelect, selectedRestaurantId.value]
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (isLoadingTotals.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[10] || (_cache[10] = [
                                        _createElementVNode("span", { class: "spinner dark" }, null, -1),
                                        _createElementVNode("span", null, "Chargement des totaux...", -1)
                                    ]))]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("label", null, _toDisplayString(_ctx.$t('common.cashReal') || 'Espèces réelles') + " (CHF)", 1),
                                            _createElementVNode("div", _hoisted_12, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((actualCash).value = $event)),
                                                    type: "number",
                                                    step: "0.05",
                                                    placeholder: "0.00",
                                                    class: "form-control"
                                                }, null, 512), [
                                                    [
                                                        _vModelText,
                                                        actualCash.value,
                                                        void 0,
                                                        { number: true }
                                                    ]
                                                ]),
                                                _createElementVNode("span", {
                                                    class: "suggestion",
                                                    onClick: _cache[3] || (_cache[3] = ($event) => (actualCash.value = theoreticalCash.value))
                                                }, [
                                                    _cache[11] || (_cache[11] = _createTextVNode(" Théorique: ", -1)),
                                                    _createElementVNode("strong", null, _toDisplayString(formatPrice(theoreticalCash.value)), 1)
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("label", null, _toDisplayString(_ctx.$t('common.cardReal') || 'Carte/Autres réel') + " (CHF)", 1),
                                            _createElementVNode("div", _hoisted_14, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((actualCard).value = $event)),
                                                    type: "number",
                                                    step: "0.05",
                                                    placeholder: "0.00",
                                                    class: "form-control"
                                                }, null, 512), [
                                                    [
                                                        _vModelText,
                                                        actualCard.value,
                                                        void 0,
                                                        { number: true }
                                                    ]
                                                ]),
                                                _createElementVNode("span", {
                                                    class: "suggestion",
                                                    onClick: _cache[5] || (_cache[5] = ($event) => (actualCard.value = theoreticalCard.value))
                                                }, [
                                                    _cache[12] || (_cache[12] = _createTextVNode(" Théorique: ", -1)),
                                                    _createElementVNode("strong", null, _toDisplayString(formatPrice(theoreticalCard.value)), 1)
                                                ])
                                            ])
                                        ])
                                    ]),
                                    (!closureSummary.value)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: _normalizeClass(["live-gap-info", { 'has-gap': currentGap.value !== 0 }])
                                        }, [
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("span", null, "Total Théorique: " + _toDisplayString(formatPrice(theoreticalTotal.value)), 1),
                                                _createElementVNode("span", null, "Total Réel: " + _toDisplayString(formatPrice(currentActualTotal.value)), 1)
                                            ]),
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["gap-final", { 'gap-negative': currentGap.value < 0, 'gap-positive': currentGap.value > 0 }])
                                            }, [
                                                _cache[13] || (_cache[13] = _createTextVNode(" Écart actuel: ", -1)),
                                                _createElementVNode("strong", null, _toDisplayString(formatPrice(currentGap.value)), 1)
                                            ], 2)
                                        ], 2))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("label", null, _toDisplayString(_ctx.$t('common.notes') || 'Commentaires / Justification'), 1),
                                        _withDirectives(_createElementVNode("textarea", {
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((notes).value = $event)),
                                            class: "form-control textarea",
                                            placeholder: "Ex: Écart de 5 CHF dû à une erreur de rendu de monnaie...",
                                            rows: "3"
                                        }, null, 512), [
                                            [_vModelText, notes.value]
                                        ]),
                                        (currentGap.value !== 0 && !notes.value)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Un commentaire est recommandé en cas d'écart de caisse. "))
                                            : _createCommentVNode("", true)
                                    ])
                                ])),
                            (error.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(error.value), 1))
                                : _createCommentVNode("", true),
                            (closureSummary.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('pos.closureSummary') || 'Résumé de la clôture'), 1),
                                    _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('pos.theoreticalTotal') || 'Total Théorique') + ":", 1),
                                            _createElementVNode("strong", null, _toDisplayString(formatPrice(closureSummary.value.theoreticalTotal)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_22, [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('pos.actualTotal') || 'Total Réel') + ":", 1),
                                            _createElementVNode("strong", null, _toDisplayString(formatPrice(closureSummary.value.actualTotal)), 1)
                                        ]),
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["summary-item", { 'gap-negative': closureSummary.value.gap < 0, 'gap-positive': closureSummary.value.gap > 0 }])
                                        }, [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('pos.gap') || 'Écart') + ":", 1),
                                            _createElementVNode("strong", null, _toDisplayString(formatPrice(closureSummary.value.gap)), 1)
                                        ], 2)
                                    ]),
                                    (closureSummary.value.notes)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                                            _cache[14] || (_cache[14] = _createElementVNode("strong", null, "Commentaire :", -1)),
                                            _createTextVNode(" " + _toDisplayString(closureSummary.value.notes), 1)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('pos.reportSentFranchise') || 'Un rapport a été envoyé par email à la franchise.'), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                            (!closureSummary.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn-cancel",
                                    onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.$emit('close')))
                                }, _toDisplayString(_ctx.$t('common.cancel')), 1))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "btn-confirm",
                                    onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.$emit('close')))
                                }, _toDisplayString(_ctx.$t('common.close') || 'Fermer'), 1)),
                            (!closureSummary.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    class: "btn-confirm btn-danger",
                                    disabled: isLoading.value || !selectedRestaurantId.value || (actualCash.value === 0 && actualCard.value === 0),
                                    onClick: handleClosure
                                }, [
                                    (isLoading.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_27))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('pos.confirmClosure') || 'Confirmer la clôture'), 1)
                                ], 8, _hoisted_26))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
